import React from 'react';
import { Helmet } from 'react-helmet';
import CssHeader from './CssHeader';
import Header from './Header';
import Footer from './Footer';
import IncludeSidebar from './IncludeSidebar';
import IncludeMariigeCertificate from "./IncludeMariigeCertificate";

function RefundPolicy() {
	return (
		<>
		  <Helmet>
			<title>Court Marriage - Refund Policy</title>
			<meta name="description" content="Court Marriage- Refund Policy" />
			<meta name="keywords" content="Delhi Court Marriage - Refund Policy" />
		  </Helmet>
		  <CssHeader />
		  <Header />
		  <div id="main" className="site-main hfeed site">
			<div id="main-content" className="main-content">
			  <div id="primary" className="content-area">
				<div id="content" className="site-content" role="main">				 
				
					<div id="post-52" className="post-52 page type-page status-publish hentry">
						<header class="entry-header">
							<h1 class="entry-title">Refund Policy</h1>
						</header>
						<div class="entry-content">
							<div class="fl-callout-content">
								<p class="fl-callout-title">
									<span class="fl-callout-title-text">At Court Marriage, we strive to provide seamless court marriage services. Our refund policy is as follows:
									</span>	
								</p>
                                    <p>
									Non-Refundable Fees: Government fees and processing charges are non-refundable.
									</p>
									<p>
									Service Cancellation: If the process is canceled before initiation, a partial refund may be considered.
									</p>
									<p>
									Incomplete Documentation: No refund is provided if the application is rejected due to incorrect or incomplete documents.
									</p>
									<p>
									Processing Delays: Refunds are not applicable for delays caused by government authorities.
									</p>
									<p>
									For refund requests, contact us at info@courtmarriage-gov.co.in.
									</p>
								
							</div>
						</div>
					</div>
					
				</div>
			  </div>
			  <IncludeSidebar/>
			</div>
			<IncludeMariigeCertificate/>
		  </div>
		  <Footer />
		</>
	  );
	}
	

export default RefundPolicy;
